var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.414 24.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.35;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n        opacity: 0.54;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    className: "cls-1",
    transform: "matrix(-0.017, -1, 1, -0.017, -304.604, 197.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    className: "cls-2",
    width: 24,
    height: 24,
    transform: "translate(168 308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-3",
    d: "M16.6,8.6,12,13.2,7.4,8.6,6,10l6,6,6-6Z",
    transform: "translate(168 308)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path-2",
    "data-name": "path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    className: "cls-3",
    d: "M16.6,8.6,12,13.2,7.4,8.6,6,10l6,6,6-6Z",
    transform: "translate(168 308)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownCollapse);
export default __webpack_public_path__ + "static/media/dropdownCollapse.d5c3173f78b4d1639c7548e312f7e2e6.svg";
export { ForwardRef as ReactComponent };